module.exports = __webpack_public_path__ + "media/images/pc/accessories/men/men_01-20b2e25bdfe99f7410fe135b51f02bfe.jpg";